export default __webpack_public_path__ + "static/media/dif01.30b96865.svg";